import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Auth0 access-token provider, wired up by AuthContext.
let _tokenGetter = null;
export function setTokenGetter(fn) {
  _tokenGetter = fn;
}

// Actor identity (from the Auth0 profile) attached to mutations for the audit log.
let _actor = { name: "", email: "" };
export function setActor(name, email) {
  _actor = { name: name || "", email: email || "" };
}

// Active space id, injected into element create/update payloads (multi-space support).
let _activeSpaceId = null;
export function setActiveSpace(id) {
  _activeSpaceId = id || null;
}

api.interceptors.request.use(async (config) => {
  if (_tokenGetter) {
    try {
      const token = await _tokenGetter();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {
      /* not logged in / token unavailable -> send request unauthenticated */
    }
  }
  if (_actor.name) config.headers["X-Actor-Name"] = encodeURIComponent(_actor.name);
  if (_actor.email) config.headers["X-Actor-Email"] = encodeURIComponent(_actor.email);
  const method = (config.method || "").toLowerCase();
  const url = config.url || "";
  if (_activeSpaceId && (method === "post" || method === "put") && /\/elements(\/|$)/.test(url) && config.data && typeof config.data === "object") {
    if (config.data.space_id == null) config.data = { ...config.data, space_id: _activeSpaceId };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 403) {
      toast.error("Nu ai permisiunea necesară pentru această acțiune.");
    } else if (status === 401 && !url.includes("/auth/me")) {
      toast.error("Sesiune expirată. Te rog autentifică-te din nou.");
    }
    return Promise.reject(error);
  }
);

export function fileUrl(path) {
  return path ? `${API}/files/${path}` : null;
}

export function apiError(detail) {
  if (detail == null) return "A apărut o eroare.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
